import { render, staticRenderFns } from "./AllPaymentSetting.vue?vue&type=template&id=1cc736c2&scoped=true"
import script from "./AllPaymentSetting.vue?vue&type=script&lang=js"
export * from "./AllPaymentSetting.vue?vue&type=script&lang=js"
import style0 from "./AllPaymentSetting.vue?vue&type=style&index=0&id=1cc736c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc736c2",
  null
  
)

export default component.exports